const topPos = ["top-start", "top", "top-end"];
const bottomPos = ["bottom-start", "bottom", "bottom-end"];
const startPos = ["start"];
const endPos = ["end"];
const order = {
    top: [...topPos, ...bottomPos, ...endPos, ...startPos],
    bottom: [...bottomPos, ...topPos, ...endPos, ...startPos],
    start: [...startPos, ...endPos, ...topPos, ...bottomPos],
    end: [...endPos, ...startPos, ...topPos, ...bottomPos],
};
/**
 * Get an order of positions to try to fit popover on the screen based on its starting position
 */
const getPositionOrder = (position) => {
    const types = ["top", "bottom", "start", "end"];
    const type = types.find((type) => position.startsWith(type)) ?? "bottom";
    return order[type];
};
export default getPositionOrder;
